module.exports = "<div class=\"row\">\n    <div class=\"col-12\">\n      <multiselect-dropdown\n      [settings]=\"languageDDSettings\"\n      [data]=\"languages\"\n      [(ngModel)]=\"selectedLanguagesInternal\"\n      (onSelect)=\"languageChange($event)\"\n      (onDeSelect)=\"languageChange($event)\"\n      (onSelectAll)=\"languageChange($event)\"\n      (onDeSelectAll)=\"languageChange($event)\">\n      </multiselect-dropdown>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/global/language-picker/language-picker.component.html
// module id = ./client/app/global/language-picker/language-picker.component.html
// module chunks = main